module.exports = __webpack_public_path__ + "assets/img/empty.1a301082.png";